export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";